module.exports = __webpack_public_path__ + "static/media/porto.311b6837.svg";